import { format } from 'date-fns';
import Button from '@mui/material/Button';
import { dateFnsFormat } from 'constants';
import { ButtonIcon } from 'components/Ui/styled';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { renderCellExpand } from 'components/Common/GridCell/GridCellExpand';

export const userLinksColumns = (handleUnView, handleGoToLink) => [
  {
    field: 'action',
    headerName: 'Action',
    width: 80,
    align: 'center',
    sortable: false,
    renderCell: (params) => {
      return (
        <>
          <ButtonIcon
            onClick={() => handleGoToLink(params)}
            data-testid="goToLinkButtonIcon"
            title="Open Link"
          >
            <OpenInNewIcon />
          </ButtonIcon>
        </>
      );
    },
  },
  // {
  //   field: 'mark',
  //   headerName: 'Mark',
  //   width: 80,
  //   align: 'center',
  //   sortable: false,
  //   renderCell: (params) => {
  //     const { status } = params.row;
  //     const isViewed = status === 'viewed';

  //     return (
  //       <>
  //         <Button
  //           size="small"
  //           onClick={() => handleUnView(params)}
  //           data-testid="unViewButton"
  //         >
  //           {isViewed ? 'Un-view' : 'View'}
  //         </Button>
  //       </>
  //     );
  //   },
  // },
  {
    headerName: 'Name',
    field: 'name',
    renderCell: renderCellExpand,
    flex: 1,
  },
  // {
  //   headerName: 'Status',
  //   field: 'status',
  //   renderCell: renderCellExpand,
  //   flex: 1,
  // },
  {
    headerName: 'Description',
    field: 'description',
    renderCell: renderCellExpand,
    flex: 1,
  },
  // {
  //   headerName: 'Active',
  //   field: 'active',
  //   type: 'boolean',
  //   flex: 1,
  // },
  {
    headerName: 'Active Until',
    field: 'activeUntil',
    flex: 1,
  },
];

export const getUserLinksListData = (adminLinksData) => {
  if (!adminLinksData.links || adminLinksData.links?.length === 0) {
    return [];
  }

  return adminLinksData.links?.map((item) => ({
    id: item?.id,
    status: item?.status,
    url: item?.trainingLink?.url,
    name: item?.trainingLink?.name,
    active: item?.trainingLink?.active,
    description: item?.trainingLink?.description,
    activeUntil: item?.trainingLink?.activeUntil
      ? format(new Date(item?.trainingLink?.activeUntil), dateFnsFormat)
      : '',
  }));
};
